<div class="split-button" >
    <!-- BOUTON PRINCIPAL -->
    <button
            class="main-btn btn {{severity}} {{styleClass}}"
            [class.full-border]="!items.length || items.length === 0"
            [disabled]="disabled"
            [matTooltip]="tooltip"
            (click)="onPrimary()">
        @if (faIcon) {
            <i class="{{ faIcon }}"></i>
        }
        {{ label }}
    </button>

    <!-- BOUTON FLECHE + MENU -->
    @if (items?.length) {
        <button
                class="caret-btn btn {{severity}}"
                [disabled]="disabled"
                [matMenuTriggerFor]="menu"
                aria-label="Plus d'actions">
            <i class="fa-solid fa-angle-down"></i>
        </button>
    }

    <mat-menu #menu="matMenu" xPosition="after">
        @for (item of items; track item.label) {
            <button mat-menu-item
                    [disabled]="item.disabled"
                    [matTooltip]="item.tooltip"
                    (click)="onItemClick(item)">
                @if (item.icon) {
                    <mat-icon>{{ item.icon }}</mat-icon>
                }
                <span>{{ item.label }}</span>
            </button>
        } @empty {

        }
    </mat-menu>
</div>
